export default __webpack_public_path__ + "static/media/electronicsun.12cb7ff6.png";